// @flow

import * as React from 'react';

import { Badge, Base, Text } from '@gandi/ui';

import Breadcrumb from './Breadcrumb';
import ShapedPlaceholder from './ShapedPlaceholder';

function SearchResultPlaceholder(): React.Element<typeof Base> {
  return (
    <Base
      flex
      flexRow
      flexJustifyBetween
      backgroundColor="white"
      padding="small"
      borderedBottom
      borderColor="grey-light"
    >
      <Base flex flexCol>
        <Base flex marginBottom="xsmall">
          <ShapedPlaceholder>
            <Base tagName="h1" size="base" weight="semibold" margin="none">
              <Text color="base">Lorem ipsum dolor sit amet</Text>
            </Base>
          </ShapedPlaceholder>
        </Base>

        <Base flex>
          <ShapedPlaceholder>
            <Base tagName="p" size="small" margin="none">
              <Breadcrumb path={['lorem', 'ipsum']} />
            </Base>
          </ShapedPlaceholder>
        </Base>
      </Base>

      <Base flex flexJustifyEnd flexAlignItemsCenter>
        <ShapedPlaceholder>
          <Badge variant="plain">Lorem ipsum</Badge>
        </ShapedPlaceholder>
      </Base>
    </Base>
  );
}

export default SearchResultPlaceholder;
